import { Component, input } from '@angular/core';
import { ScrollVisibleDirective } from '../../Directives/scroll-visible.directive';

@Component({
  selector: 'av-content-container',
  standalone: true,
  imports: [ScrollVisibleDirective],
  templateUrl: './av-content-container.component.html',
  styleUrls: ['./av-content-container.component.scss'],
})
export class AvContentContainerComponent {
  readonly fullHeight = input<boolean>(false);
}
